import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';

export interface CronJob {
  id: string;
  name: string;
  jobName: string;
  queue: string;
  intervalLabel: string;
  isScheduled: boolean;
  /** Epoch ms of the next run, or null when the cron is not scheduled. */
  next: number | null;
}

export const cronJobsQueryKey = ['CronJobs'];

/**
 * Polls on a short interval because the page's whole job is to show whether a
 * cron is alive right now, and because a restart is asynchronous — the row flips
 * to scheduled only once the scheduler has picked the job up.
 */
export const useCronJobsQuery = () => {
  const { sessionState } = useAuth();
  const isReady = isSignedIn(sessionState);

  return useQuery({
    queryKey: cronJobsQueryKey,
    queryFn: async () => {
      const { data } = await get<CronJob[]>('/v1.0/internals/crons');
      return data;
    },
    enabled: isReady,
    refetchInterval: 10_000,
    staleTime: 0,
  });
};

export default useCronJobsQuery;
